<template>
  <div class="container-fluid">
    <div class="row">
      <div :class="{ 'col-md-8': bookId, 'col-md-12': !bookId }">
        <card>
          <div class="header">
            <h4 class="title">Edição de Obra</h4>
          </div>
          <div class="content">
            <form @submit.prevent.stop="submit()">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Mídia</label>
                    <select
                      name="midia"
                      id=""
                      class="form-control border-input"
                      v-model="obra.midia_id"
                    >
                      <option
                        v-for="(midia, index) in midias"
                        :key="`midia-${index}`"
                        :value="midia.id"
                      >
                        {{ midia.nome_midia }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Categoria</label>
                    <select
                      name="categoria"
                      id=""
                      class="form-control border-input"
                      v-model="obra.categoria_id"
                    >
                      <option
                        v-for="(categoria, index) in categorias"
                        :key="`categoria-${index}`"
                        :value="categoria.id"
                      >
                        ({{ categoria.id }}) - {{ categoria.nome_categoria }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-8">
                  <div class="form-group">
                    <label>Título</label>
                    <input
                      name="titulo"
                      type="text"
                      class="form-control border-input"
                      v-model="obra.titulo"
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label>Volume</label>
                    <input
                      type="number"
                      name="volume"
                      min="0"
                      step="1"
                      class="form-control border-input"
                      v-model="obra.volume"
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label>Páginas</label>
                    <input
                      type="number"
                      name="paginas"
                      min="0"
                      step="1"
                      class="form-control border-input"
                      v-model="obra.paginas"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Subtítulo</label>
                    <input
                      type="text"
                      name="subtitulo"
                      class="form-control border-input"
                      v-model="obra.subtitulo"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Sinopse</label>
                    <rich-text v-model="obra.sinopse" />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Autores</label>
                    <div class="row">
                      <div class="col-md-10 col-9">
                        <multiselect
                          @remove="update"
                          @input="update"
                          :multiple="true"
                          track-by="id"
                          label="nome"
                          v-model="obra.autores"
                          :options="autores"
                        ></multiselect>
                      </div>
                      <div class="col-md-2 col-3">
                        <button
                          class="btn btn-default"
                          title="Adicionar Autor"
                          @click.prevent.stop="addAuthor()"
                        >
                          <i class="fa fa-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Tags</label>
                    <div class="row">
                      <div class="col-md-10 col-9">
                        <multiselect
                          @remove="update"
                          @input="update"
                          :multiple="true"
                          track-by="id"
                          label="nome_tag"
                          v-model="obra.tags"
                          :options="tags"
                        ></multiselect>
                      </div>
                      <div class="col-md-2 col-3">
                        <button
                          class="btn btn-default"
                          title="Adicionar Tag"
                          @click.prevent.stop="addTag()"
                        >
                          <i class="fa fa-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-8">
                  <div class="form-group">
                    <label>Editora</label>
                    <div class="row">
                      <div class="col-md-9 col-9 padding-zero">
                        <multiselect
                          @remove="update"
                          @input="update"
                          track-by="id"
                          label="nome_editora"
                          v-model="obra.editora"
                          :options="editoras"
                        ></multiselect>
                      </div>
                      <div class="col-md-3 col-3">
                        <button
                          class="btn btn-default"
                          title="Adicionar Editora"
                          @click.prevent.stop="addEditora()"
                        >
                          <i class="fa fa-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label>Edição</label>
                    <input
                      type="number"
                      name="edicao"
                      class="form-control border-input"
                      v-model="obra.edicao"
                    />
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="form-group">
                    <label>Ano</label>
                    <input
                      type="number"
                      name="ano"
                      class="form-control border-input"
                      v-model="obra.ano"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label>Quantidade</label>
                    <input
                      :disabled="bookId !== undefined"
                      type="number"
                      name="quantidade"
                      class="form-control border-input"
                      v-model="obra.quantidade"
                    />
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="form-group">
                    <label>Idioma</label>
                    <select
                      name="idioma"
                      id=""
                      class="form-control border-input"
                      v-model="obra.idioma_id"
                    >
                      <option
                        v-for="(idioma, index) in idiomas"
                        :key="`idioma-${index}`"
                        :value="idioma.id"
                      >
                        {{ idioma.nome_idioma }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-md-7">
                  <div class="form-group">
                    <label>Coleção</label>
                    <div class="row">
                      <div class="col-md-9 col-9 padding-zero">
                        <multiselect
                          @remove="update"
                          @input="update"
                          track-by="id"
                          label="nome_colecao"
                          v-model="obra.colecao"
                          :options="colecoes"
                        ></multiselect>
                      </div>
                      <div class="col-md-3 col-3">
                        <button
                          class="btn btn-default"
                          @click.prevent.stop="addColecao()"
                          title="Adicionar Coleção"
                        >
                          <i class="fa fa-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="isSuperUser" class="row">
                <div class="col-md-6">
                  <button
                    v-if="obra.disponivel"
                    class="btn-success btn btn-block btn-default"
                    @click.prevent.stop="obra.disponivel = false"
                    title="Disponível"
                  >
                    Disponível
                  </button>
                  <button
                    v-else
                    class="btn-danger btn btn-block btn-default"
                    @click.prevent.stop="obra.disponivel = true"
                    title="Disponível"
                  >
                    Indisponível
                  </button>
                </div>
              </div>
              <div v-if="isSuperUser" class="row">
                <div v-if="!obra.disponivel" class="col-md-12">
                  <div class="form-group">
                    <label>Motivo Indisponível</label>
                    <input
                      name="motivo indisponível"
                      type="text"
                      class="form-control border-input"
                      v-model="obra.motivo_indisponivel"
                    />
                  </div>
                </div>
              </div>

              <div class="text-center">
                <button type="submit" class="btn btn-info btn-fill btn-wd">
                  Salvar Obra
                </button>
              </div>
            </form>
          </div>
        </card>
      </div>
      <div class="col-md-4" v-if="bookId">
        <book-items
          :items="obra.items"
          @edit="editItem($event)"
          @add="addItem()"
        ></book-items>
      </div>
    </div>
  </div>
</template>
<script>
import ColecaoService from '../services/colecao-service'
import EditoraService from '../services/editora-service'
import TagService from '../services/tag-service'
import AuthorsService from '../services/authors-service'
import Multiselect from 'vue-multiselect'
import ObraService from '../services/obra-service'
import OverlayService from '../services/overlay-service'
import BookItems from '../components/Livros/BookItems.vue'
import ItemService from '../services/item-service'
import RichText from '../components/RichText.vue'

import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    Multiselect,
    BookItems,
    RichText
  },

  computed: {
    ...mapState(['editoras', 'colecoes', 'idiomas', 'tags', 'autores','categorias', 'midias']),
    ...mapGetters(['isSuperUser']),
  },

  watch: {
    $route(to, from) {
      this.bookId = this.$route.params.id
      if (this.midias.length) {
        if (this.bookId) {
          this.loadObra()
        } else {
          this.obra = this.newObra()
        }
      }
    }
  },

  data() {
    return {
      bookId: undefined,
      obra: this.newObra()
    }
  },

  mounted() {

    this.bookId = this.$route.params.id

    if (this.bookId) {
      this.loadObra()
    }
  },

  methods: {
    newObra() {
      return {
        idioma_id: 1,
        midia_id: 1,
        categoria_id: 1,
        autores: [],
        tags: [],
        sinopse: null
      }
    },

    update() {
      this.$forceUpdate()
    },

    loadObra() {
      OverlayService.trigger('show', true)

      ObraService.findOneById(this.bookId)
        .then((response) => response.data)
        .then((obra) => {
          OverlayService.trigger('show', false)
          this.obra = obra

          this.obra.autores = this.obra.autores.map(({id, nome_autor}) => { return { id, nome: nome_autor} } )
        })
        .catch((er) => OverlayService.trigger('show', false))
    },
    addTag() {
      this.$alertify.promptWithTitle(
        'Adicionar Tag',
        'Digite o nome da tag',
        '',
        (ev, nome_tag) => {
          TagService.create({nome_tag})
            .then(() => {
              this.$alertify.success('Tag criada com sucesso!')
              this.$store.dispatch('getTags')
            })
            .catch((er) => this.$alertify.error('Erro ao criar tag'))
        },
        () => {}
      )

      return false
    },

    addAuthor() {
      this.$alertify.promptWithTitle(
        'Adicionar Autor',
        'Digite o nome do autor',
        '',
        (ev, nome_autor) => {
          AuthorsService.create({ nome_autor })
            .then(() => {
              this.$alertify.success('Autor criado com sucesso!')
              this.$store.dispatch('getAutores')
            })
            .catch((er) => this.$alertify.error('Erro ao criar autor'))
        },
        () => {}
      )

      return false
    },

    addEditora() {
      this.$alertify.promptWithTitle(
        'Adicionar Editora',
        'Digite o nome da editora',
        '',
        (ev, nome_editora) => {
          EditoraService.create({ nome_editora })
            .then(() => {
              this.$alertify.success('Editora criada com sucesso!')
              this.$store.dispatch('getEditoras')
            })
            .catch((er) => this.$alertify.error('Erro ao criar editora'))
        },
        () => {}
      )

      return false
    },

    addColecao() {
      this.$alertify.promptWithTitle(
        'Adicionar Coleção',
        'Digite o nome da coleção',
        '',
        (ev, nome_colecao) => {
          ColecaoService.create({nome_colecao})
            .then(() => {
              this.$alertify.success('Coleção criada com sucesso!')
              this.$store.dispatch('getColecoes')
            })
            .catch((er) => this.$alertify.error('Erro ao criar coleção'))
        },
        () => {}
      )

      return false
    },

    submit() {
      const obraToSave = Object.assign({}, this.obra)

      obraToSave.authors = obraToSave.autores.map(({id}) => id)
      obraToSave.tags = obraToSave.tags.map(({id}) => id)
      Object.assign(obraToSave, { editora_id: (this.obra.editora || { id: null }).id })
      Object.assign(obraToSave, { colecao_id: (this.obra.colecao || { id: null }).id })

      if (!this.bookId) {
        this.create(obraToSave)
      } else {
        this.save(obraToSave)
      }
    },

    save(obra) {
      OverlayService.trigger('show', true)
      ObraService.save(obra, this.bookId)
        .then(() => {
          this.$alertify.success('Obra salva com sucesso')
          OverlayService.trigger('show', false)
        })
        .catch((er) => {
          OverlayService.trigger('show', false)
          const erro = (er.response || {}).data || {}

          const mensagem = Object.keys(erro).map(key => erro[key]).join(', ')
          this.$alertify.error(mensagem)
        })
    },

    create(obra) {
      OverlayService.trigger('show', true)
      ObraService.create(obra)
        .then((value) => {
          this.$alertify.success('Obra salva com sucesso')
          OverlayService.trigger('show', false)
          window.location.href = '/#/editBook/' + value.data.id
        })
        .catch((er) => {
          OverlayService.trigger('show', false)

          const erro = (er.response || {}).data || {}

          const mensagem = Object.keys(erro).map(key => erro[key]).join(', ')
          this.$alertify.error(mensagem)
        })
    },

    loadItems() {
      ItemService.getByObraId(this.bookId)
        .then((response) => response.data)
        .then((items) => {
          this.obra.items = items
        })
        .catch((er) => {
          this.$alertify.error('Erro ao recuperar items')
        })
    },

    editItem(item) {
      ItemService.edit(item.id, item)
        .then(() => {
          this.loadItems()
        })
        .catch((er) => this.$alertify.error('Erro ao submeter mudança'))
    },

    addItem() {
      ItemService.addItem(this.bookId)
        .then(() => this.loadItems())
        .catch((er) => this.$alertify.error('Erro ao criar novo item'))
    },

    beforeDestroy() {
      this.$store.dispatch('getObras')
    },
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.sinopse {
  height: 200px;
}
</style>
